import React, { useCallback, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	onChange: (value: Nullable<number>) => void;
	disabled: boolean;
}

const FranchiseFixedFeeThresholdField: React.FC<IProps> = ({ onChange, disabled }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => (disabled ? [] : [{ required: true, message: t('enterFranchiseFixedFeeThreshold') }]),
		[t, disabled],
	);

	const handleChange = useCallback(
		(value: Nullable<number>) => {
			onChange(value);
		},
		[onChange],
	);

	return (
		<FormInput
			testId="FranchiseFixedFeeThresholdField"
			name="franchiseFixedFeeThreshold"
			label="franchiseFixedFeeThresholdLabel"
			type="number"
			onChangeNumber={handleChange}
			validationRules={validationRules}
			min={0}
			precision={0}
			disabled={disabled}
		/>
	);
};

export default React.memo(FranchiseFixedFeeThresholdField);
